import { render, staticRenderFns } from "./dimension.vue?vue&type=template&id=4abd7dcf&"
import script from "./dimension.vue?vue&type=script&lang=js&"
export * from "./dimension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports